"use strict";

import EventEmitter from 'eventemitter2';
import Browser from '../util/browser'
import BtnHamburger from '../btn/btnhumberger';
import BtnPageTop from '../btn/btnpagetop';
import BtnTab from '../btn/btntab';
import BtnSpot from '../btn/btnspot';
import BtnMovie from '../btn/btnmovie';
import DecoCircle from '../parts/decocircle';
import Ashiato from '../parts/ashiato';
import Ashiato2 from '../parts/ashiato2';
import Youtube from '../parts/youtube';
import Kentei from '../parts/kentei';

import Header from '../section/header';
import Gnav from '../section/gnav';

class Top extends EventEmitter{
	constructor(){
		super();
	}
	
	init(){
		createjs.Ticker.init();
		createjs.Ticker.setFPS(60);
		createjs.Ticker.addEventListener('tick',createjs.Tween);
		
		//Header
		this.header = new Header( $('#Header') );

		//Gnav
		this.gnav = new Gnav( $('#Gnav') );
				
		//BtnHamburger
		this.btnHamburger = new BtnHamburger( $('#BtnHamburger') );
		
		//PageTop
		this.btnPageTop = new BtnPageTop( $('#BtnPageTop') );
		
		//Kentei
		this.kentei = new Kentei( $('#Quiz') );
		
		//BtnSpot
		this.btnSpot = new BtnSpot( $('#BtnSpot') );
		
		this.btnSanpoBottom = new BtnTab( $('#BtnZoom') );
		
		//DecoCircle
		$('.DecoCircle').each((i,v)=>{
			$(v).data('decocircle' , new DecoCircle( $(v) ) );
		})
		
		//BtnMovie
		$('.BtnMovie').each((i,v)=>{
			$(v).data('btnmovie' , new BtnMovie( $(v) ) );
		})
		
		
		this.emit('init1');
	}
	
	init2(){
		//Youtube
		Youtube.initYoutube();
		
		this.initEvent();
		
		this.emit('init2');	
	}
	
	start(){
		this.initScPosition();
		this.header.start();
		
		//TopKvTalk
		this.topkvtalk = new TopKvTalk();
	}
	
	initScPosition(){
	}
		
	initEvent(){

		let navToggleFunc = ()=>{
			if(this.gnav.isOpen){
				this.gnav.close();
				this.btnHamburger.close();
			} else {
				this.gnav.open();				
				this.btnHamburger.open();
			}
		};
		this.btnHamburger.on('click' , navToggleFunc);
		this.gnav.on('nav_click' , (id)=>{
			navToggleFunc();
			this.tabChange(id,false,1);
		});
	}

	tabChange(id,scroll,scrollduration){
	}
	
	tabBtnChange(id){
	}

}


class TopKvTalk{
	constructor(){
		this.$con = $('#TopKvTalk') ;
		this.$talks = this.$con.find('.talk');
		this.currentIndex = 0;
		
/*
		this.$talks.each((i,v)=>{
			console.log(this);
			console.log(i,v);
		});
*/
		
		this.change();	
	}
	
	change(){
		this.talkShow( this.$talks.eq(this.currentIndex) );

		this.currentIndex++;
		if( this.currentIndex >= this.$talks.length ){
			this.currentIndex = 0;
		}
	}
	
	talkShow($talk){
		let len = $talk.find('.item').length;
		let delay = 1300;
		$talk.find('.item').each((i,v)=>{
			$(v).velocity('stop').velocity({opacity:1,translateY:[0,6]},{duration:900,visibility:'visible',delay:i*delay,easing:'easeOutExpo'});
		});
		
		setTimeout(()=>{
			this.talkHide($talk);
		},len*delay+1000);
	}
	
	talkHide($talk){
		$talk.find('.item').each((i,v)=>{
			$(v).velocity('stop').velocity({opacity:0,translateY:-20},{duration:700,visibility:'hidden',delay:i*100,easing:'swing'});
		});
		
		setTimeout(()=>{
			this.change();
		},1400);
	}
	
}


export default Top;


// WEBPACK FOOTER //
// ./js/main/top.js